export default __webpack_public_path__ + "static/media/poster25.ab589497.png";